import ReducerRegistry from '../base/redux/ReducerRegistry';
import { RESET_WHITEBOARD, SETUP_WHITEBOARD } from './actionTypes';
const DEFAULT_STATE = {
    isOpen: false
};
ReducerRegistry.register('features/whiteboard', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SETUP_WHITEBOARD: {
            return Object.assign(Object.assign({}, state), { isOpen: true, collabDetails: action.collabDetails });
        }
        case RESET_WHITEBOARD:
            return DEFAULT_STATE;
    }
    return state;
});
